<app-centered-layout>
  <app-sign-in></app-sign-in>
</app-centered-layout>